import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { TextField } from "@mui/material";
import { StepContainer } from "../StepContainer";

const Container = styled.div`
  width: 100%;
`;

export interface Props {
  handleNext: (name: string) => void;
  handlePrevious: () => void;
}

export const NewDepotStep = ({ handleNext, handlePrevious }: Props) => {
  const [name, setName] = useState<string>("");
  const { t } = useTranslation();
  const onNextDisabled = !name?.trim();

  return (
    <StepContainer
      testid="new-depot-step"
      title={t("transactionWizard.newDepotStep.title")}
      onNext={() => {
        if (onNextDisabled) return;
        handleNext(name!);
      }}
      onNextDisabled={onNextDisabled}
      onPrevious={handlePrevious}
    >
      <Container>
        <TextField
          autoComplete="off"
          label={t("transactionWizard.newDepotStep.name")}
          data-testid="name"
          fullWidth
          onChange={(event) => {
            setName(event.target.value);
          }}
          type="text"
          value={name}
          slotProps={{
            htmlInput: {
              style: { textAlign: "left" },
              "data-testid": "name-input",
            },
          }}
        />
      </Container>
    </StepContainer>
  );
};
